import { AuctionBidsRepository } from 'application/repositories/AuctionBidsRepository';
import {
    AuctionBidsDetailResponse,
    AuctionBidsPriceResponse,
} from 'domain/entities/AuctionBidsEntity';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';

export class AuctionBidsUseCase implements AuctionBidsAPIUseCaseInterface {
    private auctionBidsRepo: AuctionBidsRepository;
    constructor(auctionBidsRepo: AuctionBidsRepository) {
        this.auctionBidsRepo = auctionBidsRepo;
    }

    async getAuctionBidsDetail(params: { auctionId: number }): Promise<AuctionBidsDetailResponse> {
        return await this.auctionBidsRepo.getAuctionBidsDetail(params);
    }
    async updateDealProcedures(params: {
        propertyDealProcedures: {
            buyerMemberType: string;
            loanUseStatus: number;
        };
        auctionId: number;
    }): Promise<PostPutDeleteBaseResponse> {
        return await this.auctionBidsRepo.updateDealProcedures(params);
    }
    async getAuctionBidsPrice(params: {
        listedPropertyId: number;
    }): Promise<AuctionBidsPriceResponse> {
        return await this.auctionBidsRepo.getAuctionBidsPrice(params);
    }
    async creatAuctionBids(params: {
        auctionId: number;
        scheduleSeq: number;
        bidPrice: number;
    }): Promise<PostPutDeleteBaseResponse> {
        return await this.auctionBidsRepo.creatAuctionBids(params);
    }
}
export interface AuctionBidsAPIUseCaseInterface {
    getAuctionBidsDetail(params: { auctionId: number }): Promise<AuctionBidsDetailResponse>;
    updateDealProcedures(params: {
        propertyDealProcedures: {
            buyerMemberType: string;
            loanUseStatus: number;
        };
        auctionId: number;
    }): Promise<PostPutDeleteBaseResponse>;
    getAuctionBidsPrice(params: { listedPropertyId: number }): Promise<AuctionBidsPriceResponse>;
    creatAuctionBids(params: {
        auctionId: number;
        scheduleSeq: number;
        bidPrice: number;
    }): Promise<PostPutDeleteBaseResponse>;
}
